export const TAG_LABELS = {
  license: 'Licence',
  flags: 'Flags',
  geo: 'Geo',
  contact: 'Email',
  emails: 'E-mails',
  support_chat: 'Support Chat',
  locales: 'Locales',
  registration: 'Registration',
  themes: 'Themes',
}

export const HOLIDAY_THEME_ENUM = {
  DEFAULT: 'default',
  CHRISTMAS: 'christmas',
  CHINESE_NEW_YEAR: 'chinese-new-year',
  HALLOWEEN: 'halloween',
  VALENTINE: 'valentine',
  PATRICK: 'patrick',
  EASTER: 'easter',
}

export const HOLIDAY_THEME_OPTIONS = [
  { value: HOLIDAY_THEME_ENUM.DEFAULT, label: 'Default' },
  { value: HOLIDAY_THEME_ENUM.CHRISTMAS, label: 'Christmas' },
  { value: HOLIDAY_THEME_ENUM.CHINESE_NEW_YEAR, label: 'Chinese New Year' },
  { value: HOLIDAY_THEME_ENUM.HALLOWEEN, label: 'Halloween' },
  { value: HOLIDAY_THEME_ENUM.VALENTINE, label: 'Valentine' },
  { value: HOLIDAY_THEME_ENUM.PATRICK, label: 'Patrick' },
  { value: HOLIDAY_THEME_ENUM.EASTER, label: 'Easter' },
]

export const EMAIL_CONTACT_TARGETS = [
  { target: 'support', label: 'Support' },
  { target: 'kyc', label: 'KYC' },
  { target: 'vip', label: 'VIP' },
  { target: 'info', label: 'Info' },
  { target: 'promo', label: 'Promo' },
]

export const REGISTRATION_TYPE_ENUM = {
  FAST: 'fast',
  TWO_STEP: 'two_step',
}

export const REGISTRATION_TYPE_OPTIONS = [
  { value: REGISTRATION_TYPE_ENUM.FAST, label: 'One step' },
  { value: REGISTRATION_TYPE_ENUM.TWO_STEP, label: 'Two step' },
]

export const CONFIG_EDITOR_TABS = [
  { value: 'geo', label: 'Geo' },
  { value: 'locales', label: 'Locales' },
  { value: 'emails', label: 'E-Mails' },
  { value: 'feature-flag', label: 'Feature Flag' },
  { value: 'holiday-themes', label: 'Holiday Themes' },
  { value: 'support-chat', label: 'Support Chat' },
  { value: 'license', label: 'License' },
]

export const LICENSE_LINK_TARGET_OPTIONS = [
  { value: '_blank', label: 'Blank' },
  { value: '_self', label: 'Self' },
]

export const LICENSE_IMAGE_TYPE_OPTIONS = [
  { value: 'basic-small', label: 'basic-small' },
]
